import React from "react";
import { FaEnvelope, FaInstagram } from "react-icons/fa";
import "../styles/GlobalStyles.css";

const Contact = () => (
  <main
    className="page-wrap"
    style={{ maxWidth: "560px", marginLeft: "auto", marginRight: "auto" }}
  >
    <span className="pill">Contact</span>
    <h2 style={{ marginBottom: "8px" }}>Get in Touch</h2>
    <p style={{ color: "var(--mid)", marginBottom: "32px" }}>
      Have a question or want to book? Reach out — I'd love to hear from you.
    </p>

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        maxWidth: "480px"
      }}
    >
      {/* Email */}
      <div
        className="card"
        style={{ display: "flex", alignItems: "center", gap: "14px" }}
      >
        <FaEnvelope
          style={{ fontSize: "1.4rem", color: "var(--mocha)", flexShrink: 0 }}
        />
        <div>
          <p
            style={{
              fontSize: "0.7rem",
              fontWeight: 700,
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              color: "var(--mocha)",
              marginBottom: "2px"
            }}
          >
            Email
          </p>
          <a
            href="mailto:afterglobeautyco@gmail.com"
            style={{ color: "var(--dark)", fontSize: "0.98rem" }}
          >
            afterglobeautyco@gmail.com
          </a>
        </div>
      </div>

      {/* Instagram */}
      <div
        className="card"
        style={{ display: "flex", alignItems: "center", gap: "14px" }}
      >
        <FaInstagram
          style={{ fontSize: "1.4rem", color: "var(--mocha)", flexShrink: 0 }}
        />
        <div>
          <p
            style={{
              fontSize: "0.7rem",
              fontWeight: 700,
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              color: "var(--mocha)",
              marginBottom: "2px"
            }}
          >
            Instagram
          </p>
          <a
            href="https://www.instagram.com/afterglobeautyco/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--dark)", fontSize: "0.98rem" }}
          >
            @afterglobeautyco
          </a>
        </div>
      </div>
    </div>

    <div style={{ position: "relative", maxWidth: "480px", marginTop: "8px" }}>
      <img
        src="/contactme.jpg"
        alt="Contact Courtney"
        style={{
          width: "100%",
          borderRadius: "var(--radius-lg, 20px)",
          boxShadow: "var(--shadow-lg)",
          objectFit: "cover",
          display: "block"
        }}
      />
      {/* Dark gradient overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          borderRadius: "var(--radius-lg, 20px)",
          background:
            "linear-gradient(to bottom, rgba(0,0,0,0.62) 0%, rgba(0,0,0,0.18) 55%, transparent 100%)"
        }}
      />
      {/* CTA buttons overlaid at top */}
      <div
        style={{
          position: "absolute",
          top: "24px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "calc(100% - 48px)"
        }}
      >
        <a
          href="https://afterglobeautyco.square.site/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary btn-full"
        >
          Book an Appointment
        </a>
        <a
          href="https://g.page/r/CbS3eYDcq_46EBM/review"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-outline btn-full"
          style={{
            background: "rgba(255,255,255,0.15)",
            color: "#fff",
            borderColor: "rgba(255,255,255,0.6)"
          }}
        >
          Leave Me a Review ♡
        </a>
      </div>
    </div>
  </main>
);

export default Contact;
